import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { Funcionalidade } from '@/models/funcionalidade';
import { Pagination } from './pagination';

export class FuncionalidadeAPI extends BaseAPI<Funcionalidade> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_dash/v1/functionalities`;
  }

  public create(body: any): AxiosObservable<Funcionalidade> {
    return this.axios.post(`${this.apiUrl}`, body);
  }

  public list(params: any): AxiosObservable<Pagination<Funcionalidade>> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) });
  }

  public show(id: number): AxiosObservable<Funcionalidade> {
    return this.axios.get(`${this.apiUrl}/${id}`)
  }

  public update(id: number, body: any): AxiosObservable<Funcionalidade> {
    return this.axios.patch(`${this.apiUrl}/${id}`, body)
  }
}
